import React from "react";
import whiteTopImg from "../../assets/images/png/white_top_vector.png";
import orangeTopImg from "../../assets/images/png/orange_top_vector.png";
import bottomFlowerImg from "../../assets/images/svg/bottom_flower.svg";
import topFlowerImg from "../../assets/images/svg/top_flower.svg";
import rightVectorImg from "../../assets/images/finest-knowledge/png/right-vector.png";
import leftVectorImg from "../../assets/images/finest-knowledge/png/left-vector.png";
import yogaFirstStep from "../../assets/images/finest-knowledge/svg/yoga-step-first.svg";
import yogaSecondStep from "../../assets/images/finest-knowledge/svg/yoga-step-second.svg";
import yogaThirdStep from "../../assets/images/finest-knowledge/svg/yoga-step-third.svg";
import yogaFourthStep from "../../assets/images/finest-knowledge/svg/yoga-step-fourth.svg";

const FinestKnowledge = () => {
  return (
    <>
      <div
        className="bg_orange py-5 position-relative characteristics_bg z_index_1"
        id="yoga-program"
      >
        {/* WHITE TOP VECTOR IMAGE */}
        <img
          className="position-absolute end-0 w-100 white_top_vector"
          src={whiteTopImg}
          alt="vector"
        />
        {/* BOTTOM ORANGE VECTOR IMAGE */}
        <img
          className="position-absolute end-0 w-100 common_orange_bottom_layer"
          src={orangeTopImg}
          alt="vector"
        />
        {/* BOTTOM FLOWER VECTOR IMAGE */}
        {/*<img
          className="position-absolute end-0 bottom-0 characteristics_bottom_flower bottom_flower_mahamantra z_index_1"
          src={bottomFlowerImg}
          alt="bottom_flower"
        />*/}
        {/* TOP FLOWER VECTOR IMAGE */}
        {/* <img
          className="position-absolute top_flower_mahamantra finest_card_flower_top finest_flower_top"
          src={topFlowerImg}
          alt="top_flower"
        />*/}
        {/* RIGHT VECTOR IMAGE */}
        <img
          className="position-absolute end-0 d-none d-lg-block bottom-0"
          src={rightVectorImg}
          alt="right-vector"
        />
        {/* LEFT VECTOR IMAGE */}
        <img
          className="position-absolute d-none d-lg-block bottom-0"
          src={leftVectorImg}
          alt="left-vector"
        />
        <div className="container container_modified py-lg-5 mt-3 mt-sm-5">
          <div className="pt-4 pt-sm-3 pt-xl-5 mt-xl-3">
            <h3 className="text-light-yellow text-uppercase common_heading_text">
              Trimurti Ashram
            </h3>
            <h4 className="font-2xl fw-bold text-white text-center mb-0 pt-2">
              World's Finest Knowledge <br className="d-none d-xl-block" />&
              Meditation
            </h4>
          </div>
          <div className="row pt-4 mt-2 pb-4 pb-sm-0">
            <div className="col-md-10 col-lg-8 col-xl-6 mx-auto mx-xl-0 position-relative z_index_1">
              <div className="finest_card_bg">
                <h5 className="font-xmd fw-semibold text-dark-gray mb-0">
                  Early AM
                </h5>
                <div className="d-flex">
                  <div className="pt-sm-4 mt-3 mt-sm-2">
                    <div className="d-flex finest_card_size">
                      <p className="font-sm fw-semibold text-dark-gray finest_card_text_width">
                        5:30
                      </p>
                      <span className="px-2">-</span>
                      <p className="font-sm fw-medium text-dark-gray">
                        Bell for rising
                      </p>
                    </div>
                    <div className="d-flex finest_card_size">
                      <p className="font-sm fw-semibold text-dark-gray finest_card_text_width">
                        6-7:30
                      </p>
                      <span className="px-2">-</span>
                      <p className="font-sm fw-medium text-dark-gray">
                        Integral Yoga instruction
                      </p>
                    </div>
                    <div className="d-flex finest_card_size">
                      <p className="font-sm fw-semibold text-dark-gray finest_card_text_width text-sm-nowrap">
                        7:30-8:30
                      </p>
                      <span className="px-2">-</span>
                      <p className="font-sm fw-medium text-dark-gray">
                        Morning Sahej Dhyan (Spontaneous Meditation) instrution
                      </p>
                    </div>
                    <div className="d-flex finest_card_size">
                      <p className="font-sm fw-semibold text-dark-gray finest_card_text_width mb-0">
                        8:30-9
                      </p>
                      <span className="px-2">-</span>
                      <p className="font-sm fw-medium text-dark-gray mb-0">
                        Breakfast
                      </p>
                    </div>
                  </div>
                  <div className="finest_first_img pe-2 pe-sm-0">
                    <img src={yogaFirstStep} alt="yoga-step-first" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-10 col-lg-8 col-xl-6 mx-auto mx-xl-0 pt-4 pt-xl-0 position-relative z_index_1">
              <div className="finest_card_bg">
                <h5 className="font-xmd fw-semibold text-dark-gray mb-0">
                  Morning
                </h5>
                <div className="d-flex justify-content-between justify-content-sm-start">
                  <div className="pt-sm-4 mt-3 mt-sm-2">
                    <div className="d-flex finest_card_size">
                      <p className="font-sm fw-semibold text-dark-gray finest_card_text_width">
                        9-9:30
                      </p>
                      <span className="px-2">-</span>
                      <p className="font-sm fw-medium text-dark-gray">
                        Free time
                      </p>
                    </div>
                    <div className="d-flex finest_card_size">
                      <p className="font-sm fw-semibold text-dark-gray finest_card_text_width">
                        10-11:30
                      </p>
                      <span className="px-2">-</span>
                      <p className="font-sm fw-medium text-dark-gray">
                        The experience of Meditation
                      </p>
                    </div>
                    <div className="d-flex finest_card_size">
                      <p className="font-sm fw-semibold text-dark-gray finest_card_text_width text-sm-nowrap">
                        11:30-noon
                      </p>
                      <span className="px-2">-</span>
                      <p className="font-sm fw-medium text-dark-gray">
                        Free time
                      </p>
                    </div>
                    <div className="d-flex finest_card_size">
                      <p className="font-sm fw-semibold text-dark-gray finest_card_text_width mb-0">
                        Noon-1
                      </p>
                      <span className="px-2">-</span>
                      <p className="font-sm fw-medium text-dark-gray mb-0">
                        Lunch
                      </p>
                    </div>
                  </div>
                  <div className="finest_second_img pe-4 pe-sm-0 ps-sm-5 ps-xl-4">
                    <img
                      className="w-100"
                      src={yogaSecondStep}
                      alt="yoga-step-second"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-10 col-lg-8 col-xl-6 mx-auto mx-xl-0 pt-4 pt-xl-0 position-relative z_index_1">
              <div className="finest_card_bg">
                <h5 className="font-xmd fw-semibold text-dark-gray mb-0">
                  Afternoon
                </h5>
                <div className="d-flex justify-content-between justify-content-sm-start">
                  <div className="pt-sm-4 mt-3 mt-sm-2">
                    <div className="d-flex finest_card_size">
                      <p className="font-sm fw-semibold text-dark-gray finest_card_text_width">
                        1-2
                      </p>
                      <span className="px-2">-</span>
                      <p className="font-sm fw-medium text-dark-gray">Rest</p>
                    </div>
                    <div className="d-flex finest_card_size">
                      <p className="font-sm fw-semibold text-dark-gray finest_card_text_width">
                        2-4
                      </p>
                      <span className="px-2">-</span>
                      <p className="font-sm fw-medium text-dark-gray text-nowrap">
                        Yoga Asanas
                      </p>
                    </div>
                    <div className="d-flex finest_card_size">
                      <p className="font-sm fw-semibold text-dark-gray finest_card_text_width">
                        4-5
                      </p>
                      <span className="px-2">-</span>
                      <p className="font-sm fw-medium text-dark-gray text-nowrap">
                        Afternoon talk
                      </p>
                    </div>
                    <div className="d-flex finest_card_size">
                      <p className="font-sm fw-semibold text-dark-gray finest_card_text_width">
                        5-6
                      </p>
                      <span className="px-2">-</span>
                      <p className="font-sm fw-medium text-dark-gray">
                        Afternoon meditation period
                      </p>
                    </div>
                    <div className="d-flex finest_card_size">
                      <p className="font-sm fw-semibold text-dark-gray finest_card_text_width mb-0 text-sm-nowrap">
                        6:45-7:30
                      </p>
                      <span className="px-2">-</span>
                      <p className="font-sm fw-medium text-dark-gray mb-0">
                        Dinner
                      </p>
                    </div>
                  </div>
                  <div className="finest_third_img pe-4 pe-sm-0 ps-sm-5 ps-xl-0">
                    <img
                      className="w-100"
                      src={yogaThirdStep}
                      alt="yoga-step-third"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-10 col-lg-8 col-xl-6 mx-auto mx-xl-0 pt-4 pt-xl-0 position-relative z_index_1">
              <div className="finest_card_bg">
                <h5 className="font-xmd fw-semibold text-dark-gray mb-0">
                  Evening
                </h5>
                <div className="d-flex justify-content-between justify-content-sm-start justify-content-xl-between">
                  <div className="pt-sm-4 mt-3 mt-sm-2">
                    <div className="d-flex finest_card_size">
                      <p className="font-sm fw-semibold text-dark-gray finest_card_text_width">
                        7:30-8
                      </p>
                      <span className="px-2">-</span>
                      <p className="font-sm fw-medium text-dark-gray text-nowrap">
                        Free time
                      </p>
                    </div>
                    <div className="d-flex finest_card_size">
                      <p className="font-sm fw-semibold text-dark-gray finest_card_text_width">
                        8-9:15
                      </p>
                      <span className="px-2">-</span>
                      <p className="font-sm fw-medium text-dark-gray">
                        Evening check-in <br className="d-none d-sm-block" />
                        and spiritual talk
                      </p>
                    </div>
                    <div className="d-flex finest_card_size">
                      <p className="font-sm fw-semibold text-dark-gray finest_card_text_width text-nowrap">
                        9:30
                      </p>
                      <span className="px-2">-</span>
                      <p className="font-sm fw-medium text-dark-gray text-nowrap">
                        Lights out
                      </p>
                    </div>
                  </div>
                  <div className="finest_fourth_img pe-2 ps-sm-5 ps-xl-0">
                    <img
                      className="w-100"
                      src={yogaFourthStep}
                      alt="yoga-step-fourth"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FinestKnowledge;
